import React, {useState} from "react";


function SectionHeader({customSection, addCustomSectionFunction}){

    return (
        <div>
            <div className="row p-2">
                <h5 className="col-11">
                    {customSection ? "Custom Sections" : "Default Sections"}
                </h5>
                {customSection &&  <button type="button" className="btn btn-secondary ml-2"  onClick = {addCustomSectionFunction}>
                    <i className="fa fa-plus" />
                </button>}
            </div>

            <div className="row p-2  border-bottom">
                <h6 className="col-4">

                </h6>
                <h6 className="col-4">
                    Notes
                </h6>
                <h6 className="col-1">
                    Active
                </h6>
                <h6 className="col-1">
                    Required
                </h6>
                <h6 className="col-1">
                    Loc Object
                </h6>
                <h6 className="col-1">
                    Copy
                </h6>
                {customSection && <h6 className="col-1">
                    Delete
                </h6>}
            </div>
        </div>

    )

}

export default SectionHeader
